<template>
  <div class="actor_message">
    <div v-if="!isServerError">
      <section class="text_center" v-if="actor != null">
        <h2 class="header_underline">{{ title }}</h2>

        <div class="actor_message_input">
          <h3 v-if="!isComplete">{{ actorName }}</h3>
          <router-view v-bind:form.sync="form" v-bind:actor.sync="actor" @input="form = $event" />
        </div>
      </section>
    </div>
    <div v-else>
      <section class="not_found text_center">
        <div>
          <p>鑑定師が見つかりませんでした。</p>
          <p><router-link :to="{ name: 'Top' }" class="arrow link_main--text">トップページへ戻る</router-link></p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { GET_ACTOR_BY_SEND_MESSAGE } from '@/store/actor/actions'

export default {
  name: 'ActorMessage',
  data () {
    return {
      id: this.$route.params.id,
      actor: null,
      form: {
        errors: [],
        text: ''
      },
      isServerError: false
    }
  },
  computed: {
    title () {
      let titleStr = ''
      if (this.isComplete) {
        titleStr = '鑑定依頼完了'
      } else if (this.$route.meta.isConfirm) {
        titleStr = '鑑定依頼内容確認'
      } else if (!this.$route.meta.isConfirm) {
        titleStr = '鑑定依頼内容入力'
      }
      return titleStr
    },
    actorName () {
      return (this.actor == null) ? '' : `${this.actor.name}先生へ`
    },
    isComplete () {
      const meta = this.$route.meta || {}
      return 'isConfirm' in meta === false
    }
  },
  methods: {
    getActor () {
      this.actor = null

      this.$store.dispatch(GET_ACTOR_BY_SEND_MESSAGE, {
        id: this.id
      })
        .then((data) => {
          if (data.is_point_shortage) {
            this.$router.pushIsses({ name: 'UserPointShortage' })
          } else {
            this.actor = data
          }
        })
        .catch(() => {
          this.$router.go(-1)
        })
    }
  },
  created () {
    this.getActor()
  }
}
</script>
